import { Controller, Season, Matchday, Phase, TimeUpdateEvent, VideoReloadEvent, TimeoutEvent } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../Event/PhaseChangeEvent";

// uses srvg.timelinePhases, srvg.debug, srvg.debugView

export class TimelineController extends Controller {
    name: string;
    url: string;
    currentSeason: Season;
    nextSeason: Season;
    currentMatchday: Matchday;
    currentPhase: Phase;
    initialized: boolean;
    private timeout: any;
    private pollTimeOnErrorInMs: number;

    dateHeaderWarning: boolean;
    active_phase_end_datetime: number;

    constructor(options){
        options = options || {};
        super(options);
        this.name = 'timelineController';

        this.url = options.url || '';

        this.currentSeason = null;
        this.nextSeason = null;
        this.currentMatchday = null;
        this.currentPhase = null;
        this.initialized = false;

        this.timeout = null;
        this.pollTimeOnErrorInMs = 10000;
        this.active_phase_end_datetime = 0;

        this.generatedEvents.push( PhaseChangeEvent );
        this.generatedEvents.push( TimeUpdateEvent );
        this.generatedEvents.push( VideoReloadEvent );
    }




    /**
     * Return the server data by analysing the date header or the content of a timings response
     * Uses local storage for detecting cached responses
     */
    getServerTime(response, dateHeader) {
        try {
            let dateHeaderserverTime;
            if (dateHeader !== undefined) {
                const date = new Date(dateHeader);
                dateHeaderserverTime = Math.floor(date.getTime() / 1000);
            }
            else {
                if (!this.dateHeaderWarning) {
                    this.dateHeaderWarning = true;
                    console.warn('No date header in timings feed. Application might be out of sync with server time.');
                }
                dateHeaderserverTime = response.server_time;
            }
            
            let item: any  = window.localStorage.getItem(this.getLocalStoragePrefix());
            if (item) {
                item = JSON.parse(item);
            }

            try {
                if (!item || (dateHeaderserverTime != item.server_timestamp)) {
                    let client_timestamp = Math.floor(Date.now()/1000);
                    window.localStorage.setItem(this.getLocalStoragePrefix(), JSON.stringify({
                        client_timestamp: client_timestamp,
                        server_timestamp: dateHeaderserverTime
                    }));
                } else {
                    // Response from browser cache, compensate
                    const storedServerTimestamp = item.server_timestamp;
                    const storedClientTimestamp = item.client_timestamp;
                    const timeDelta = storedClientTimestamp - storedServerTimestamp;
                    dateHeaderserverTime = Math.floor(Date.now()/1000) + timeDelta;
                }
            } catch(err) {
                console.error('Timestamp could not be saved to localstorage:', err);
            }

            // Patch the response
            response.server_time = dateHeaderserverTime;

            return dateHeaderserverTime;
        }
        catch(error) {
            return Math.floor(Date.now()/1000);
        }
    }

    /**
     * Constructs the prefix string used for local storage
     */
    getLocalStoragePrefix() {
        return 'srvg_vbl'+this.url+'_'+srvg.config.scout;
    }


    /* fetch timeline feed*/
    poll(){
        let dateHeader = '';
        const url = this.url+'?ts='+this.active_phase_end_datetime;

        fetch(url)
            .then(response => {
                dateHeader = response.headers.get('date');
                return response;
            })
            .then(response => response.json())
            .then(data => {
                const serverTime = this.getServerTime(data, dateHeader);
                this.active_phase_end_datetime = data.active_phase_end_datetime;

                //srvg.debugView.log( this.name, 'Competition ' + data.season.continuous_counter + ' match day ' + data.matchday  +': entered new phase ' + that.getGeneralPhaseName(data.phase_id) + ' (ends in ' + (data.active_phase_end_datetime-app.server.getTime()) + ' seconds)' );
                this.triggerEvent( new TimeUpdateEvent( data.server_time ) );

                if (data.countdown && data.countdown > 0){

                    const countdownAdjustment = data.countdown - data.next_phase;

                    data.countdown = data.active_phase_end_datetime - serverTime + countdownAdjustment;
                    data.next_phase = data.active_phase_end_datetime - serverTime;

                    if( this.currentSeason && this.currentSeason.id != data.season_id ) {
                        this.currentSeason.destroy();
                        this.currentSeason = null;
                    }
                    if( !this.currentSeason ) {
                        this.currentSeason = new Season( data.season_id, data.season.continuous_counter, data.season.start_datetime, data.season.end_datetime );
                    }
                    if( this.nextSeason && data.next_season && this.nextSeason.id != data.next_season.id ) {
                        this.nextSeason.destroy();
                        this.nextSeason = null;
                    }
                    if( !this.nextSeason ) {
                        this.nextSeason = data.next_season ? new Season( data.next_season.id, data.next_season.continuous_counter, data.next_season.start_datetime, data.next_season.end_datetime ) : null;
                    }
                    this.currentMatchday = this.currentSeason.getMatchday(data.matchday);
                    this.currentPhase = new Phase( data.phase_id, this.getGeneralPhaseName(data.phase_id), data.active_phase_start_datetime, data.active_phase_end_datetime );

                    if( this.nextSeason ) {
                        // Link the two seasons
                        this.nextSeason.prev = this.currentSeason;
                        this.currentSeason.next = this.nextSeason;

                        // prevent old seasons from sticking around
                        if( this.currentSeason.prev ) {
                            this.currentSeason.prev.destroy();
                            this.currentSeason.prev = null;
                        }

                        // Link the last days of the current season and the first day of the next season
                        this.nextSeason.getMatchday(1).prev = this.currentSeason.getMatchday(this.currentSeason.numberOfSporteventSets);
                        this.currentSeason.getMatchday(this.currentSeason.numberOfSporteventSets).next = this.nextSeason.getMatchday(1);
                    }

                    this.triggerEvent( new PhaseChangeEvent(
                        this.currentMatchday,
                        this.currentSeason,
                        this.currentPhase
                    ) );

                    //that.triggerEvent( new VideoReloadEvent( data.video_reload, !!this.init ) ); FIXME

                    /**
                     * If new season begins and feature is enabled, reload the window
                     */
                    if(data.active_phase == 'season_intro' && this.initialized && srvg.featuresInstances.getReloadAfterCompetition()) {
                        window.location.reload();
                    }
                    this.initialized = true;

                    //this.init = true;
                    // poll JSON feed
                    var timeToNextCall = parseInt(data.next_phase,10)*1000+1000;
                    this.timeout = setTimeout(function() {
                        this.poll();
                    }.bind(this), timeToNextCall);
                } else if (data.countdown === 0 || data.countdown < 0) {
                    this.timeout = setTimeout(function() {
                        this.poll();
                    }.bind(this), 1000);
                } else {
                    this.timeout = setTimeout(function() {
                        this.poll();
                    }.bind(this), this.pollTimeOnErrorInMs);
                }

            })
            .catch(error => {
                this.timeout = setTimeout(function() {
                    this.poll();
                }.bind(this), this.pollTimeOnErrorInMs);
            });

    }

    handleTimeoutEvent(event:TimeoutEvent){
        clearTimeout(this.timeout);
    }

    getGeneralPhaseName(phase_value){
        for (var phase_name in srvg.timelinePhases) {
            if ( srvg.timelinePhases[phase_name].id===phase_value ) {
                return phase_name;
            }
        }
        srvg.debug.console( 'General phase name for phase ' + phase_value + ' not found' )
        return phase_value;
    }

    startPolling(){
        this.poll();
    }
}
